// extracted by mini-css-extract-plugin
export default {"itemParameters":"_3Mi6t","itemKeyWrapper":"_2f_AE","itemName":"_7v9ji","itemValuesWrapper":"_1qxGU","itemValue":"_1fmXt","parametersList":"_1czPf"};